<template>
  <div class="commonDialogBody">
           <OrganizationalStructure @AllData="getMsgFormSon" style="display:none" />
    <el-dialog
        :close-on-click-modal='false'
        :title="title"
         :visible.sync="dialogVisible"
         
        width="50%"
        :destroy-on-close="true"
        :before-close="handleClose">
        <div style="width:70%;margin-left:5%;">
<el-form :label-position="labelPosition" label-width="100px" :model="formLabelAlign" style="width:75%;" >
  <el-form-item :label="formLabelAlign.obj.code">
    <el-input v-model="formLabelAlign.subjectsCode" size="small"></el-input>
  </el-form-item>
      <el-form-item :label="formLabelAlign.obj.name" >
     <el-input v-model="formLabelAlign.subjectsName" size="small"></el-input>
    </el-form-item>
    <el-form-item :label="formLabelAlign.obj.superior" v-show="UserDisplay == 1">
     <el-input v-model="formLabelAlign.parentCode" size="small" disabled></el-input>
    </el-form-item>
  <el-form-item :label="formLabelAlign.obj.item" >
    <el-select  clearable v-model="valueone" placeholder="请选择支出项目"  size="small" @change="TenementType" >
        <el-option v-for="item in optionsone" :key="item.valueone" :label="item.labelone" :value="item.valueone"></el-option>
    </el-select>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.attribute" >
    <el-select  clearable v-model="disburseval" placeholder="请选择科目属性"  size="small" @change="TenementType" >
        <el-option v-for="item in disburse" :key="item.disburseval" :label="item.disburselab" :value="item.disburseval"></el-option>
    </el-select>
  </el-form-item>
    <el-form-item :label="formLabelAlign.obj.remark" >
     <el-input v-model="formLabelAlign.subjectRemarks" size="small"></el-input>
    </el-form-item>
</el-form>
</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()" v-debounce>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import OrganizationalStructure from "../common/OrganizationalStructure.vue";
export default {
 components: {OrganizationalStructure},
  name: "ChargeDialog",
  data() {
    return {
    options:[], // 组织结构
     value: [],
     optionsone: [{
          valueone: '1',
          labelone: '是'
        }, {
          valueone: '0',
          labelone: '否'
        }],
        value: '',
        valueone: '',
        disburse:[{
          disburseval: '0',
          disburselab: '预算'
        }, {
          disburseval: '1',
          disburselab: '非预算'
        },
        {
          disburseval: '2',
          disburselab: '其他'
        }],
        disburseval:"",
        dialogVisible: false,
     title:"标题",
     labelPosition:'right',
     formLabelAlign:{},
     type:"",
     display:"",
     detection:"",
     UserDisplay:"",
    };
  },
  methods: {
      handleChange(value){
      },
      TenementType(valueone){
      },
    modification(){
        if(this.title == "修改"){
             let obj = {
               "id":this.formLabelAlign.id,
                "subjectsCode":this.formLabelAlign.subjectsCode,
                "subjectsName":this.formLabelAlign.subjectsName,
                "expendItem":this.valueone,
                "subjectAttributes":this.disburseval,
                "subjectRemarks":this.formLabelAlign.subjectRemarks,
                }
                  if(obj.subjectsCode == undefined){
                    this.$message({
                        type: "warning",
                        message: "请填写科目代号"
                    })
                }else if(obj.subjectsName == undefined){
                    this.$message({
                        type: "warning",
                        message: "请填写科目名称"
                    })
                }else{
                    this.$http.post(this.$requestUrl.POST_CHARGE,obj).then((res) => {
                         if(res.data.code == 200){
                          this.dialogVisible = false
                          this.$emit("Visible",false)
                           this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
                        }
                    }).catch(()=>{
                        this.$message.error(this.$errorMessage.SEVER_ERROR)
                    })
                }
        }else{
            if(this.UserDisplay == 1){
                  let obj = {
                "subjectsCode":this.formLabelAlign.subjectsCode,
                "subjectsName":this.formLabelAlign.subjectsName,
                "parentCode":this.formLabelAlign.parentCode,
                "expendItem":this.valueone,
                "subjectAttributes":this.disburseval,
                "subjectRemarks":this.formLabelAlign.subjectRemarks,
                }
                  if(obj.subjectsCode == undefined){
                    this.$message({
                        type: "warning",
                        message: "请填写科目代号"
                    })
                }else if(obj.subjectsName == undefined){
                    this.$message({
                        type: "warning",
                        message: "请填写科目名称"
                    })
                }else{
                    this.$http.post(this.$requestUrl.POST_CHARGE,obj).then((res) => {
                         if(res.data.code == 200){
                          this.dialogVisible = false
                          this.$emit("Visible",false)
                          this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
                        }
                    }).catch(()=>{
                        this.$message.error(this.$errorMessage.SEVER_ERROR)
                    })
                }
            }else{
            let obj = {
                "subjectsCode":this.formLabelAlign.subjectsCode,
                "subjectsName":this.formLabelAlign.subjectsName,
                "expendItem":this.valueone,
                "subjectAttributes":this.disburseval,
                "subjectRemarks":this.formLabelAlign.subjectRemarks,
                }
                if(obj.subjectsCode == undefined){
                    this.$message({
                        type: "warning",
                        message: "请填写科目代号"
                    })
                }else if(obj.subjectsName == undefined){
                    this.$message({
                        type: "warning",
                        message: "请填写科目名称"
                    })
                }else{
                    this.$http.post(this.$requestUrl.POST_CHARGE,obj).then((res) => {
                        if(res.data.code == 200){
                          this.dialogVisible = false
                          this.$emit("Visible",false)
                          this.$message({
                              type: 'success',
                              message: '修改成功!'
                          });
                        }
                    }).catch(()=>{
                        this.$message.error(this.$errorMessage.SEVER_ERROR)
                    })
                }
            }
        }

    },
    getMsgFormSon(data){
        this.options = data
    },
    cs(){
    this.valueone = this.formLabelAlign.expendItem
    this.disburseval = this.formLabelAlign.subjectAttributes
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    amend(){
    }
  },
    //组件创建之后
  created() {

  },
    //页面渲染之前
  beforeMount() {
    if(this.UserDisplay == 1){
        this.valueone =""
        this.disburseval =""
    }
      if(this.formLabelAlign.obj == undefined){
         let obj = {
            "code":"科目代号",
            "name":"科目名称",
            "item":"支出项目",
            "attribute":"科目属性",
            "remark":"备注信息",
          }
      this.formLabelAlign.obj = obj
    }
  },
}
</script>

<style scoped lang="scss">
// .commonDialogBody {

// }
</style>